import { createStore } from 'redux';
import { rootReducer } from './reducers';

const enhancer =
    (window as any).__REDUX_DEVTOOLS_EXTENSION__ &&
    (window as any).__REDUX_DEVTOOLS_EXTENSION__();

export const store = createStore(rootReducer, enhancer);
